import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { useLocation } from "react-router-dom";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface lesson{
    name:string,
    teacher:string,
    days:Array<string>,
    time_start:string,
    time_end:string,
    etc:string
}

interface teacher{
    name:string,
    uid:string,
}

const useLessonRegister = () => {
    const lesson_id = useLocation().state;
    const {getBranchId} = useGetBranchId();
    const {readFirestoreWithQuery, readFirestoreOneDoc, addFireStore, updateFirestore, deleteFirestore} = useFirestore();
    const [teachers, setTeacher] = useState<teacher[]>([]);
    const [isDuplicated, setIsDuplicated] = useState(null);
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucced] = useState(false);
    const [isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal] = useState(false)
    const [isOpenNullModal, setIsOpenNullModal] = useState(false);
    const [inputLesson, setInputLesson] = useState<lesson>({
        name:"",
        teacher:"",
        days:[],
        time_start:"",
        time_end:"",
        etc:""
    })

    useEffect(() => {
        getTeacher();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(lesson_id){
            getLessonData();
        }
        // eslint-disable-next-line
    }, [lesson_id])

    const getLessonData = async() => {
        const branch_id = await getBranchId();
        readFirestoreOneDoc(`Lesson/Branch/${branch_id}`, lesson_id).then(res => {
            if(res.exists()){
                const data = res.data();
                setInputLesson({
                    name:data.name,
                    teacher:data.teacher,
                    days:data.days,
                    time_start:data.time_start,
                    time_end:data.time_end,
                    etc:data.etc
                })
            }
        })
    }

    const onChange = (e:ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
        const {name, value} = e.target;
        if(name === "days"){
            let days = inputLesson.days;
            if(inputLesson.days.includes(value)){
                days = days.filter(item => item !== value);
            }else{
                days.push(value);
            }
            setInputLesson({
                ...inputLesson,
                "days":days
            })
        }else{
            setInputLesson({
                ...inputLesson,
                [name]:value
            })
        }
    }

    const getTimeList = () => {
        const timeList: string[] = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const timeStr: string = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`; // 시간과 분을 문자열로 변환
                timeList.push(timeStr);
            }
        }
        return timeList;
    }

    const getTeacher = async() => {
        const branch_id = await getBranchId();
        readFirestoreWithQuery("User/Auth/Teacher", {field:"branch_id", operator:"==", data:branch_id}).then(res => {
            res.forEach((doc:any) => {
                setTeacher(data => [...data, {name:doc.data().name, uid:doc.id}])
            })
        })
    }

    const onSaveButtonClick = () => {
        if(lesson_id){
            update();
        }else{
            register();
        }
    }

    const register = async() => {
        const name = inputLesson.name.trim();
        const {teacher, days, time_start, time_end, etc} = inputLesson;
        if(!name || !teacher){
            setIsOpenNullModal(true);
            return;
        }

        const data = {
            name:name,
            teacher:teacher,
            days:days,
            time_start:time_start,
            time_end:time_end,
            etc:etc,
        }

        const branch_id = await getBranchId();

        
        addFireStore(`Lesson/Branch/${branch_id}`, data).then(res => {
            if(res){
                setIsSucced(true);
            }else{
                setIsError(true);
            }
        })
    }

    const update = async() => {
        const {teacher, days, time_start, time_end, etc, name} = inputLesson;
        if(!name || !teacher){
            setIsOpenNullModal(true);
            return;
        }
        const lesson_data = {
            teacher:teacher,
            days:days,
            time_start:time_start,
            time_end:time_end,
            etc:etc,
            name:name
        }
        const branch_id = await getBranchId();
        updateFirestore(`Lesson/Branch/${branch_id}`, lesson_id, lesson_data).then(res => {
            if(res){
                setIsSucced(true);
            }else{
                setIsError(true);
            }
        })
    }

    const onDeleteClickHandler = async() => {
        let result = null;
        const branch_id = await getBranchId();
        result = await deleteFirestore(`Lesson/Branch/${branch_id}`, lesson_id).then(res => {
          return res;
        })
        result = await deleteFirestore(`Assign/${branch_id}/Lesson`, lesson_id).then(res => {
            return res;
        })
        if(result){
            setIsOpenDeleteSucceedModal(true);
            return
        }
    }

    return {inputLesson, onChange, getTimeList, teachers, onSaveButtonClick, setIsDuplicated,
        isError, setIsError, isSucceed,
        isOpenNullModal, setIsOpenNullModal,
        isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal, onDeleteClickHandler
    }
}

export default useLessonRegister;